import React from "react";
import analytics from "web/script/analytics/analytics";
import { gettext } from "web/script/modules/django-i18n";
import userProfiler from "web/script/modules/userprofiler";
import AppDownloadBadge from "web/react/components/app-download-badge/app-download-badge";
import CloseButton from "web/react/components/buttons/close-button/close-button";
import mobileImage from "./images/lyst_app_mobile_screen.png";
import styles from "./app-download-banner-desktop.css";
export default function AppDownloadBannerDesktop(_ref) {
  var isOpen = _ref.isOpen,
      onClose = _ref.onClose,
      eventLabel = _ref.eventLabel;

  if (isOpen && !userProfiler.hasAppBannerShown()) {
    analytics.event("app_banner", "shown", eventLabel);
    userProfiler.saveAppBannerShown(true);
  }

  function dismissBanner() {
    analytics.event("app_banner", "dismissed", eventLabel);
    userProfiler.saveAppBannerDismissed();
    onClose();
  }

  if (isOpen) {
    return React.createElement("div", {
      className: styles.container
    }, React.createElement("img", {
      src: mobileImage,
      className: styles.appImage,
      alt: "Lyst app"
    }), React.createElement("div", {
      className: styles.titleContainer
    }, React.createElement("h1", {
      className: styles.title
    }, gettext("app_download_desktop_banner.definitive_shopping.title"))), React.createElement("div", {
      className: styles.buttons
    }, React.createElement(AppDownloadBadge, {
      color: "black",
      appDownloadLink: "desktopAppBannerFeeds",
      eventLabel: eventLabel
    }), React.createElement(CloseButton, {
      className: styles.closeButton,
      onClick: dismissBanner
    })));
  } else {
    return null;
  }
}